module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"h1":"Вход в Deliver","h2":"Для продолжения введите пароль","forgot-password":"Забыли пароль?"}}')
  delete Component.options._Ctor
}
